import { ComponentStyleConfig } from '@chakra-ui/theme'

export const Badge: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 'md',
    fontWeight: 'normal',
    px: '2',
    py: '1',
    textTransform: 'none',
  },
}
